<template>
  <div>
    <v-container class="mt-lg-10" fluid>
      <v-row dense>
        <v-col>
          <v-card>
            <v-app-bar color="primary" dark>
              <v-icon class="mr-3">mdi-filter</v-icon>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-app-bar>
            <v-container fluid>
              <v-row dense>
                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >
                    <v-select
                        :items="schemeDropdownData"
                        :label="filterBoxLabel.scheme"
                        chips
                        deletable-chips
                        dense
                        outlined
                        small-chips
                        v-model="filterBox.scheme"
                    ></v-select>
                  </v-skeleton-loader>
                </v-col>
                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >

                    <v-select
                        :items="amountRangeDropdownData"
                        :label="filterBoxLabel.amount"
                        chips
                        deletable-chips
                        dense
                        outlined
                        small-chips
                        v-model="filterBox.loanAmount"
                    ></v-select>
                  </v-skeleton-loader>
                </v-col>
                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >
                    <v-select
                        :items="statusDropdownData"
                        :label="filterBoxLabel.gfiStatus"
                        chips
                        deletable-chips
                        dense
                        outlined
                        small-chips
                        v-model="filterBox.gfiStatus"
                    ></v-select>
                  </v-skeleton-loader>
                </v-col>
                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >
                    <v-select
                        :items="applicationStatusDropdownData"
                        :label="filterBoxLabel.finAppStatus"
                        chips
                        deletable-chips
                        dense
                        outlined
                        small-chips
                        v-model="filterBox.applicationStatus"
                    ></v-select>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="col-12 col-lg-3 col-md-3">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        min-width="290px"
                        offset-y
                        transition="scale-transition"
                        v-model="menu2"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            :label="filterBoxLabel.date"
                            append-icon="event"
                            clearable
                            dense
                            outlined
                            readonly
                            v-model="filterBox.startDate"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          :max="date"
                          @input="menu2 = false"
                          no-title
                          v-model="filterBox.startDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-skeleton-loader>
                </v-col>
                <v-col
                    cols="12"
                    lg="3"
                    md="3"
                    v-if="getUserRole!=='ROLE_LOAN_OFFICER_DASHBOARD'"
                >
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="card-heading"
                  >
                    <v-select
                        :items="branchDropdownData"
                        :label="filterBoxLabel.branch"
                        chips
                        deletable-chips
                        dense
                        outlined
                        small-chips
                        v-model="filterBox.branch"
                    ></v-select>
                  </v-skeleton-loader>
                </v-col>
                <v-col
                    class="col-12 col-lg-6 col-md-6"
                    v-if="getUserRole==='ROLE_LOAN_OFFICER_DASHBOARD'"
                ></v-col>
                <v-col class="col-12 col-lg-3 col-md-3" v-else></v-col>
                <v-col
                    class="d-flex justify-lg-end justify-md-end justify-center"
                    cols="12"
                    lg="3"
                    md="3"
                >
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="button"
                  >
                    <v-btn @click="resetFilters" color="primary" dark
                    >Reset</v-btn
                    >
                  </v-skeleton-loader>
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="button"
                  >
                    <v-btn @click="filterData" class="ml-3" color="primary" dark
                    >Filter</v-btn
                    >
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="customersTablePadding" fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-app-bar color="primary" dark>
              <v-icon class="mr-3">mdi-account-group</v-icon>
              <v-toolbar-title>
                <span v-show="userType=='SME'">SME</span>
                <span v-show="userType=='MIKRO'">MIKRO</span>
                Customers
              </v-toolbar-title>
              <v-row justify="end">
                <v-dialog max-width="450" persistent v-model="appliedDialog">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="hidden-sm-and-down text-left"
                        color="primary"
                        dark
                        v-on="on"
                    >View Applied Filters
                    </v-btn>
                    <v-btn
                        class="hidden-md-and-up"
                        color="primary"
                        dark
                        v-on="on"
                    >
                      <v-icon> mdi-filter </v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Filters Applied</v-card-title>
                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                          <tr>
                            <td>{{ filterBoxLabel.scheme }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.scheme">All Schemes</td>
                            <td v-else>
                                <span :key="'SCHEME'+ index" v-for="(scheme,index) in schemeDropdownData">
                                  <span v-if="appliedFilters.scheme === scheme.value">
                                      {{scheme.text}}
                                  </span>
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ filterBoxLabel.amount }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.amount">
                              All Amount Ranges
                            </td>
                            <td v-else>
                                <span :key="'AMOUNT'+ index" v-for="(amount,index) in amountRangeDropdownData">
                                  <span v-if="appliedFilters.amount === amount.value">
                                      {{amount.text}}
                                  </span>
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ filterBoxLabel.gfiStatus }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.status">All Status</td>
                            <td v-else>
                                <span :key="'STATUS'+ index" v-for="(status,index) in statusDropdownData">
                                  <span v-if="appliedFilters.status === status.value">
                                      {{status.text}}
                                  </span>
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ filterBoxLabel.finAppStatus }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.finAppStatus">
                              All Financing Application Status
                            </td>
                            <td v-else>
                                <span :key="'FINANCE_STATUS'+ index" v-for="(finAppStatus,index) in applicationStatusDropdownData">
                                    <span v-if="appliedFilters.finAppStatus === finAppStatus.value">
                                        {{finAppStatus.text}}
                                    </span>
                                </span>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ filterBoxLabel.date }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.date">All Dates</td>
                            <td v-else>
                              {{ appliedFilters.date }}
                            </td>
                          </tr>
                          <tr v-if="getUserRole==='ROLE_HQ_OFFICER_DASHBOARD' || getUserRole==='ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD'">
                            <td>{{ filterBoxLabel.branch }}</td>
                            <td>:</td>
                            <td v-if="!appliedFilters.branch">
                              All Branches
                            </td>
                            <td v-else>
                                <span :key="'BRANCH'+ index" v-for="(branch,index) in branchDropdownData">
                                  <span v-if="appliedFilters.branch === branch.value">
                                      {{branch.text}}
                                  </span>
                                </span>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                          @click="appliedDialog = false"
                          color="green darken-1"
                          text
                      >Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-app-bar>
            <v-container class="containerStyling">
              <v-row>
                <span
                    :key="index"
                    v-for="(headers, index) in filteredHeadersForCheckBox"
                >
                  <v-col v-if="headers.toggle">
                    <v-checkbox
                        :label="headers.text"
                        color="primary"
                        v-model="headers.selectedCheckbox"
                        v-on:change="recordTicks()"
                    />
                  </v-col>
                </span>
              </v-row>
            </v-container>
            <v-card>
              <v-skeleton-loader
                  :loading="tableDataLoading"
                  transition="scale-transition"
                  type="table-tbody"
              >
                <v-card-title>
                  <v-row>
                    <v-col md="7"></v-col>
                    <v-text-field
                        hide-details
                        placeholder="Search"
                        single-line
                        v-model="search"
                    ></v-text-field>
                    <div class="pl-3 mt-2"></div>
                    <v-btn @click="filterData" class="ma-2" color="info">
                      <v-icon dark>mdi-magnify</v-icon>
                    </v-btn>
                  </v-row>
                </v-card-title>
              </v-skeleton-loader>
              <v-data-table
                  :disable-sort="true"
                  :footer-props="{'items-per-page-options': pagination.itemPerPageOptions,'show-current-page':true}"
                  :headers="filteredHeaders"
                  :items="table.tableData"
                  :options.sync="pagination"
                  :server-items-length="table.totalLength"
                  @update:options="paginate"
                  v-show="!tableDataLoading">
                <template v-slot:item.compliance="{ item }">
                  <span v-if="item.compliance">
                    {{ item.compliance }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                </template>

                  <template v-slot:item.entrepreneurship="{ item }">
                  <span v-if="item.entrepreneurship">
                    {{ item.entrepreneurship }}
                  </span>
                      <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                  </template>

                  <template v-slot:item.financial_decision_making="{ item }">
                  <span v-if="item.financial_decision_making">
                    {{ item.financial_decision_making }}
                  </span>
                      <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                  </template>

                  <template v-slot:item.application_number="{ item }">
                  <span v-if="item.application_number">
                    {{ item.application_number }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                </template>

                <template v-slot:item.test_finish_time="{ item }">
                  <span v-if="item.test_finish_time">
                    {{ item.test_finish_time }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                </template>

                <template v-slot:item.details="{ item }">
                  <v-icon
                      @click="editItem(item)"
                      class="mr-2"
                      color="blue darken-2"
                      small
                      v-if="!item.scoring_triggered_by_officer && item.status==='FINISHED'">
                      mdi-square-edit-outline
                  </v-icon>
                  <v-icon class="mr-2" color="grey darken-2" small v-else>
                    mdi-square-edit-outline
                  </v-icon>
                </template>
                <template v-slot:item.application_status="{ item }">
                  {{ item.application_status_label }}
                  <span v-if="userType=='MIKRO' && isLoanOfficer">
                    <v-icon
                        @click="editApplicationStatus(item)"
                        class="mr-2"
                        color="blue darken-2"
                        small>
                        mdi-square-edit-outline
                    </v-icon>
                  </span>
                </template>
                <template v-slot:item.scoring="{ item }">
                  <v-icon
                      @click="generateScore(item)"
                      class="mr-2"
                      color="blue darken-2"
                      small
                      v-if="item.ready_for_scoring && !item.scoring_triggered_by_officer">
                    mdi-calculator
                  </v-icon>
                  <v-icon
                      class="mr-2"
                      color="grey darken-2"
                      small
                      v-if="!item.ready_for_scoring || (item.ready_for_scoring && item.scoring_triggered_by_officer)">
                    mdi-calculator
                  </v-icon>
                </template>
                <template v-slot:item.gfi_rating="{ item }">
                  <span v-if="item.gfi_rating=== '-'">
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                  <span class="text-center" v-else>
                    {{item.gfi_rating}}
                  </span>
                </template>
                <template v-slot:item.test_taker_score_overall_score="{item}">
                  <span v-if="item.test_taker_score_overall_rating">
                  {{item.test_taker_score_overall_rating}}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>$vuetify.icons.values.mdiMinus</v-icon>
                  </span>
                </template>
                <template v-slot:item.report="{item}">
                  <span v-if="item.has_gfi_score">
                      <span v-if="checkArray(item._id,item.id_number,'BANK_REPORT')">
                        <v-icon @click.native="downloadReport(item._id,item.id_number,'BANK_REPORT')" color="success">
                          mdi-file-download
                        </v-icon>
                      </span>
                      <span v-else>
                        <v-progress-circular :size="20" color="primary" indeterminate ></v-progress-circular>
                      </span>
                    </span>
                    <span v-else>
                      <v-icon>mdi-file-download</v-icon>
                    </span>
                </template>
              </v-data-table>
              <div v-if="isFinancialAdvisoryOfficer">
                <v-card
                    class="dashboard-datatable-footer dashboardFooterBottomMargin"
                >
                  <v-card-actions class="dashboard-datatable-footer-actions">
                    <p>
                      <v-icon class="px-2" x-small
                      >mdi-checkbox-blank-circle</v-icon
                      >
                      F1 : Compliance
                    </p>
                    <p>
                      <v-icon class="px-2" x-small
                      >mdi-checkbox-blank-circle</v-icon
                      >
                      F2 : Entrepreneurship
                    </p>
                    <p>
                      <v-icon class="px-2" x-small
                      >mdi-checkbox-blank-circle</v-icon
                      >
                      F3 : Financial Decision-Making
                    </p>
                  </v-card-actions>
                </v-card>
              </div>
              <div v-if="isShowExportButtonEnabled">
                <v-skeleton-loader
                    :loading="tableDataLoading"
                    transition="scale-transition"
                    type="card-heading"
                >
                  <v-card
                      class="dashboard-datatable-footer dashboardFooterBottomMargin"
                  >
                    <v-card-actions class="dashboard-datatable-footer-actions">
                      <v-btn
                          :disabled="!enableExportButton"
                          @click="exportData"
                          class="ma-2"
                          color="info"
                      >
                        <v-progress-circular
                            :size="20"
                            color="primary"
                            indeterminate
                            v-show="exporting"
                        >
                        </v-progress-circular>
                        <span v-show="exporting">&nbsp;</span
                        >{{ $t('msg.export_button') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-skeleton-loader>
              </div>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
          max-width="450"
          persistent
          v-if="renderEditForm"
          v-model="dialog"
      >
        <v-card>
          <v-card-title class="headline"
          >Edit Customer Information</v-card-title
          >
          <v-card-text>
            <ValidationObserver ref="observerEditApplication" v-slot="{failed,passes}">
              <form>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider vid="applicationNumber" name="applicationNumber"
                      :rules="{numeric:true, max:10 }" ref="observerEditApplicationNumber"
                      v-slot="{errors, failedRules}">
                    <v-text-field class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                        label="Application No."
                        v-model="editedItem.application_number">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required:true, min : 5, max : 80, regex:/^[a-zA-Z@'/\s-]+$/ }"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'fullName')"
                        label="Full Name"
                        v-model="editedItem.fullname"
                    ></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider v-slot="{ errors, failedRules }">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'idNumber')"
                        class="requiredSticker"
                        label="Identification Number (ID)"
                        readonly
                        v-model="editedItem.id_number"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-select
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'gender')"
                        :items="editGenderFilterDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Gender"
                        v-model="editedItem.gender"
                    >
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-select
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'ethnicity')"
                        :items="editEthnicityDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Ethnicity"
                        v-model="editedItem.ethnicity"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>
                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                    v-if="editedItem.ethnicity==='O'"
                >
                  <ValidationProvider
                      :rules="{ required: true}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'otherEthnicity')"
                        label="Other Ethinicity"
                        v-model="editedItem.other_ethnicity"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true ,min:2, max:100, regex:/^[a-zA-Z0-9.&()'\s-]+$/ }"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'position')"
                        label="Position"
                        v-model="editedItem.designation"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <v-text-field
                      label="Businesss Licence No."
                      readonly
                      v-model="editedItem.business_registration_number"
                  >
                  </v-text-field>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <v-menu
                      :close-on-content-click="false"
                      min-width="290px"
                      offset-y
                      ref="menu"
                      transition="scale-transition"
                      v-model="menu"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                          :rules="{required: false }"
                          v-slot="{errors, failedRules}"
                      >
                        <v-text-field class="requiredSticker"
                            :error-messages="$translatedErrorMessages(failedRules,'commencement_date')"
                            append-icon="mdi-calendar"
                            clearable
                            label="Business Commencement Date"
                            readonly
                            v-model="editedCommencementDate"
                            v-on="on"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>

                    <v-date-picker
                        :max="date"
                        @input="menu = false"
                        color="#81c342"
                        no-title
                        scrollable
                        v-model="editedItem.commencement_date"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-skeleton-loader>

                <ValidationProvider
                    :rules="{required: false}"
                    v-slot="{errors, failedRules}"
                >
                  <v-select class="requiredSticker"
                      :error-messages="$translatedErrorMessages(failedRules,'malaysian_owned')"
                      :items="malaysianOwned"
                      item-text="text"
                      item-value="value"
                      label="Malaysian Owned"
                      clearable
                      v-model="editedItem.malaysian_owned"
                  ></v-select>
                </ValidationProvider>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true ,min:5, max:80, regex:/^[a-zA-Z0-9.&()'\s-]+$/ }"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'companyName')"
                        label="Company Name"
                        v-model="editedItem.company_name"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{ required: false}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-select class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                        :items="editBusinessCategoryDropdownData"
                        chips
                        small-chips
                        deletable-chips
                        item-text="text"
                        item-value="value"
                        label="Main Sector"
                        v-model="editedItem.business_category"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>

                <ValidationProvider
                    :rules="{required: false}"
                    v-slot="{errors, failedRules}"
                >
                  <v-select class="requiredSticker"
                      :error-messages="$translatedErrorMessages(failedRules,'ctos_description')"
                      :items="ctosItems"
                      item-text="text"
                      item-value="value"
                      label="CTOS"
                      chips
                      small-chips
                      deletable-chips
                      v-model="editedItem.ctos_description"
                  ></v-select>
                </ValidationProvider>

                  <ValidationProvider
                      :rules="{required: false ,min_value:300, max_value:850, regex:/^[a-zA-Z0-9.&()'\s-]+$/ }"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field v-show="editedItem.ctos_description === 'Y' "
                        :error-messages="$translatedErrorMessages(failedRules,'ctosRating')"
                        label="CTOS Rating"
                        v-model="editedItem.ctos_rating"
                    >
                    </v-text-field>
                  </ValidationProvider>


                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true, numeric: true, min_value:0, max_value:999999999}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'employeesCount')"
                        label="Number of full-time employee(s)"
                        v-model="editedItem.employees_count"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{ required: true, numeric: true, min_value:0, max_value:999999999}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'annualSales')"
                        label="Annual Sales"
                        prefix="RM"
                        v-model="editedItem.annual_sales"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{ required: true, numeric: true, min_value:1, max_value: editedItem.annual_sales}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'annualProfit')"
                        label="Annual Profit"
                        prefix="RM"
                        v-model="editedItem.annual_profit"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <v-text-field
                      label="Branch"
                      readonly
                      v-model="editedItem.branch"
                  >
                  </v-text-field>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required:true ,min: 5, max: 80, regex:/^[a-zA-Z@'/\s-]+$/}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'officerName')"
                        label="Staff Name"
                        v-model="editedItem.officer_in_charge"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required:true ,min: 4, max: 6, numeric: true}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'officerId')"
                        label="Staff ID"
                        v-model="editedItem.officer_in_charge_id"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <v-text-field
                      label="Scheme Applied"
                      readonly
                      v-model="editedItem.customer_product_name_label"
                  ></v-text-field>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{ required: true, numeric: true, min_value:1000, max_value:999999999}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount')"
                        label="Financing Amount"
                        prefix="RM"
                        v-model="editedItem.loan_amount"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line"
                >
                  <ValidationProvider
                      :rules="{required: true,  numeric: true, min_value:1, max_value:180}"
                      v-slot="{errors, failedRules}"
                  >
                    <v-text-field
                        class="requiredSticker"
                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied')"
                        label="Tenure"
                        suffix="Months"
                        v-model="editedItem.tenure_applied"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <div>
                    <div v-show="failed">
                        <p style="color:red" >One or more customer information have errors, please provide correct information to save successfully</p>
                    </div>
                  <div v-show="serverError">
                    <p style="color:red" >Something went wrong. Please try again later</p>
                  </div>
                </div>
                <v-card-actions align="right">
                        <p><span style="color:red">*</span> Required field</p>
                        <v-spacer></v-spacer>
                        <v-btn @click="clear" color="primary">Cancel</v-btn>
                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="button">
                            <v-btn @click="passes(updatedItem)" class="ml-4" color="primary" dark>Save</v-btn>
                        </v-skeleton-loader>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450" persistent v-model="applicationStatusDialog">
        <v-card>
          <v-card-title class="headline"
          >Update Application Status</v-card-title
          >
          <v-card-text>
            <ValidationObserver ref="observerEditApplicationStatus" v-slot="{passes}">
              <form>
                <v-skeleton-loader
                    :loading="loadingFilterData"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider
                      rules="required"
                      v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'customerApplicationStatus')"
                        :items="applicationStatusDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Application Status"
                        v-model="editApplicationItem.application_status">
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>



                <div v-if="editApplicationItem.application_status==='A'">

                    <v-skeleton-loader
                            :loading="loadingFilterData"
                            transition="scale-transition"
                            type="list-item-two-line">

                        <v-menu :close-on-content-click="false"
                                min-width="290px" offset-y
                                ref="menu5"
                                transition="scale-transition"
                                v-model="menu5">
                            <template v-slot:activator="{ on }">
                                <ValidationProvider
                                        :rules="{required: true }"
                                        v-slot="{errors, failedRules}">
                                    <v-text-field
                                            :error-messages="$translatedErrorMessages(failedRules,'approved_date')"
                                            append-icon="mdi-calendar"
                                            clearable
                                            label="Application Approval Date"
                                            readonly v-model="editedApplicationApprovedDate"
                                            v-on="on"></v-text-field>
                                </ValidationProvider>
                            </template>

                            <v-date-picker
                                    :max="date"
                                    @input="menu5 = false"
                                    color="#81c342"
                                    no-title
                                    scrollable
                                    v-model="editApplicationItem.application_approval_date"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-skeleton-loader>
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line"
                  >
                    <ValidationProvider
                        :rules="{numeric:true,required:true, min_value:1000, max_value:999999999 }"
                        v-slot="{errors, failedRules}"
                    >
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'financingAmountApproved')"
                          label="Financing Amount Approved"
                          prefix="RM"
                          v-model="editApplicationItem.financing_amount_approved"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>

                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line"
                  >
                    <ValidationProvider
                        :rules="{numeric:true,required: true, min_value: 1, max_value: 180 }"
                        v-slot="{ failedRules}"
                    >
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'tenureApproved')"
                          label="Tenure Approved"
                          suffix="Months"
                          v-model="editApplicationItem.tenure_approved"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>
                </div>
              </form>
              <div v-show="applicationServerError">
                <p style="color:red" >Something went wrong. Please try again later</p>
              </div>
              <v-card-actions align="right">
                <v-spacer></v-spacer>
                <v-btn @click="clearApplicationStatus()" color="primary"
                >Cancel</v-btn
                >
                <v-skeleton-loader
                    :loading="loadingFilterData"
                    transition="scale-transition"
                    type="button"
                >
                  <v-btn
                      @click="passes(updateApplicationStatus)"
                      class="ml-4"
                      color="primary"
                      dark
                  >
                    SAVE
                  </v-btn>
                </v-skeleton-loader>
              </v-card-actions>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog max-width="700" persistent v-model="generateScoreDialog">
        <v-card>
          <v-card-title class="headline">Generate Score</v-card-title>
          <v-card-text>
            <v-card>
              <v-card-text>
                  <v-row>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Application No."
                                  readonly
                                  v-model="editedItem.application_number">
                          </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Full Name"
                                  readonly
                                  v-model="editedItem.fullname"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Identification Number (ID)"
                                  readonly
                                  v-model="editedItem.id_number"></v-text-field>
                      </v-col>
                  </v-row>

                  <v-row>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Gender"
                                  readonly
                                  v-model="editedItem.gender_label">
                          </v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Ethnicity"
                                  readonly
                                  v-model="editedItem.ethnicity_label"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Position"
                                  readonly
                                  v-model="editedItem.designation">
                          </v-text-field>
                      </v-col>
                  </v-row>

                  <v-row>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Business Licence No."
                                  readonly
                                  v-model="editedItem.business_registration_number"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Businesss Commencement Date"
                                  readonly
                                  v-model="editedItem.commencement_date_formatted">
                          </v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                          <v-text-field
                                  label="Malaysian Owned"
                                  readonly
                                  :value="editedItem.malaysian_owned==='Y'?'Yes':'No'">

                          </v-text-field>
                      </v-col>
                  </v-row>

                <v-row>
                    <v-col cols="12" md="12">
                        <v-text-field
                                label="Company Name"
                                readonly
                                v-model="editedItem.company_name">
                        </v-text-field>
                    </v-col>
                </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                    <v-text-field
                        label="Main Sector"
                        readonly
                        v-model="editedItem.business_category_label"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="CTOS"
                        readonly
                        :value="editedItem.ctos_description==='Y'?'Yes':'No'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="CTOS Rating"
                        readonly
                        v-model="editedItem.ctos_rating"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="Number of full-time employee(s)"
                        readonly
                        v-model="editedItem.employees_count"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="Annual Sales"
                        readonly
                        v-model="editedItem.annual_sales"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="Annual Profit"
                        readonly
                        v-model="editedItem.annual_profit"
                    ></v-text-field>
                  </v-col>
                    <v-col cols="12" md="4">
                    <v-text-field
                        label="Branch"
                        readonly
                        v-model="editedItem.branch"
                    ></v-text-field>
                  </v-col>

                </v-row>

                <v-row>

                  <v-col cols="12" md="4">
                    <v-text-field
                        label="Staff Name"
                        readonly
                        v-model="editedItem.officer_in_charge"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        label="Staff ID"
                        readonly
                        v-model="editedItem.officer_in_charge_id"
                    ></v-text-field>
                  </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                                label="Scheme"
                                readonly
                                v-model="editedItem.customer_product_name_label"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                                label="Financing Amount Applied"
                                prefix="RM"
                                readonly
                                v-model="editedItem.loan_amount"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                                label="Tenure Applied"
                                readonly
                                suffix="Months"
                                v-model="editedItem.tenure_applied"
                        ></v-text-field>
                    </v-col>
                </v-row>

              </v-card-text>
            </v-card>
            <p class="mt-5"><b>Are you sure you want to generate GFI scores for this customer?
                <br />Please note that you will not be able to change the customer
                details after scores have been generated.</b>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="generateScoreDialog=false" color="primary" right
            >Cancel</v-btn
            >
            <v-btn
                @click="sendGenerateScoreRequest"
                class="mr-4"
                color="primary"
                dark
                right
            >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-snackbar
        :right="'right'"
        :timeout="4000"
        :top="'top'"
        color="success"
        v-model="updated"
    >
      Successfully Updated.
    </v-snackbar>
    <v-snackbar
        :right="'right'"
        :timeout="4000"
        :top="'top'"
        color="success"
        v-model="generateScoreSnackbar"
    >
      Successfully Triggered Generate Scores.
    </v-snackbar>
    <v-snackbar
        :right="'right'"
        :timeout="2000"
        :top="'top'"
        color="success"
        v-model="deletedSnackbar"
    >
      Successfully Removed.
    </v-snackbar>
    <v-snackbar
        :bottom="true"
        :right="true"
        :timeout="6000"
        :vertical="true"
        color="info"
        v-model="reportDownloadError"
    >
      <span v-html="$t('msg.report_unavailable')"></span>
      <v-btn
          @click="reportDownloadError = false"
          dark
          text
          v-html="$t('msg.close_label')"
      ></v-btn>
    </v-snackbar>
    <v-snackbar
        :bottom="true"
        :right="true"
        :timeout="6000"
        :vertical="true"
        color="info"
        v-model="exportDataDownloadError"
    >
      <span v-html="$t('msg.export_unavailable')"></span>
      <v-btn
          @click="exportDataDownloadError = false"
          dark
          text
          v-html="$t('msg.close_label')"
      ></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {dataServices, downloadFileService} from "../../../services";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import debounce from 'lodash/debounce'
import fileSaver from 'file-saver'

export default {
  name: 'UserList',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    userType: {
      type: String,
      default: 'SME',
      required: true
    }
  },
  data() {
    return {
      dummy: '<p style="color: red">Label</p>p',
      reportDownloadError: false,
      exporting: false,
      exportDataDownloadError: false,
      hideColumn: false,
      loadingFilterData: true,
      tableDataLoading: true,
      loading: false,
      serverError: false,
      applicationServerError: false,
      selectedSchedule: '',
      appliedFilters: {
        scheme: '',
        amount: '',
        status: '',
        finAppStatus: '',
        date: '',
        branch: ''
      },
      profile: {},
      results: {},
      editedItem: {},
      editApplicationItem: {},
      schedules: [],
      table: {
        tableData: [],
        totalLength: 0
      },
      schemeDropdownData: [],
      amountRangeDropdownData: [],
      statusDropdownData: [],
      yearDropdownData: [],
      applicationStatusDropdownData: [],
      branchDropdownData: [],
      editGenderFilterDropdownData: [],
      editBusinessCategoryDropdownData: [],
      editEthnicityDropdownData: [],
      malaysianOwned: [{
        text: 'Yes',
        value: 'Y'
      }, {
        text: 'No',
        value: 'N'
      }],
      ctosItems: [{
        text: 'Yes',
        value: 'Y'
      }, {
        text: 'No',
        value: 'N'
      }],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      menu5: false,
      search: '',
      dialog: false,
      applicationStatusDialog: false,
      appliedDialog: false,
      deletedDialog: false,
      generateScoreDialog: false,
      updated: false,
      deletedSnackbar: false,
      generateScoreSnackbar: false,
      editedCommencementDate: '',
      editedApplicationApprovedDate: '',
      requestDataArray: [''],
      renderEditForm: true,
      items: [
        {text: 'Home', disabled: true, href: 'breadcrumbs_dashboar'},
        {text: 'Manage', disabled: true, href: 'breadcrumbs_link_1'}
      ],
      filterBoxLabel: {
        scheme: this.$t('msg.scheme_label'),
        amount: this.$t('msg.amount_range_label'),
        gfiStatus: this.$t('msg.gfi_status_label'),
        finAppStatus: this.$t('msg.financing_application_status_label'),
        date: this.$t('msg.date_label'),
        branch: this.$t('msg.branch_label')
      },
      headers: [
        {
          position: 1,
          text: this.$t('msg.sl_no'),
          align: 'center',
          selectedCheckbox: false,
          toggle: false,
          value: 'slno'
        },
          {
              position: 2,
              text: this.$t('msg.application_number'),
              align: 'center',
              value: 'application_number',
              selectedCheckbox: true,
              toggle: false
        },
        {
          position: 3,
          text: this.$t('msg.br_number'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'business_registration_number',
          enableForFinanceType: ['SME']
        },
        {
          position: 4,
          text: this.$t('msg.business_licence'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'business_registration_number',
          enableForFinanceType: ['MIKRO']
        },
        {
          position: 5,
          text: this.$t('msg.company_name'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'company_name'
        },
        {
          position: 6,
          text: this.$t('msg.id_number'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'id_number'
        },
        {
          position: 7,
          text: this.$t('msg.verification_code'),
          align: 'center',
          selectedCheckbox: false,
          toggle: true,
          value: 'verification_code'
        },
        {
          position: 8,
          text: this.$t('msg.staff_id_number'),
          align: 'center',
          selectedCheckbox: false,
          toggle: true,
          value: 'officer_in_charge_id'
        },
        {
          position: 9,
          text: this.$t('msg.scheme'),
          align: 'center',
          selectedCheckbox: true,
          toggle: true,
          value: 'customer_product_name_label'
        },
        {
          position: 10,
          text: this.$t('msg.branch'),
          align: 'center',
          selectedCheckbox: true,
          toggle: true,
          value: 'branch',
          roles: ['ROLE_HQ_OFFICER_DASHBOARD', 'ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD']
        },
        {
          position: 11,
          text: this.$t('msg.financing_amount_requested'),
          align: 'center',
          selectedCheckbox: true,
          toggle: true,
          value: 'loan_amount'
        },
        {
          position: 12,
          text: this.$t('msg.assessment_type_label'),
          align: 'center',
          selectedCheckbox: false,
          toggle: true,
          value: 'assessment_type_label'
        },
        {
          position: 13,
          text: this.$t('msg.gfi_status'),
          align: 'center',
          selectedCheckbox: true,
          toggle: true,
          value: 'completion_status'
        },
        {
          position: 14,
          text: this.$t('msg.gfi_registration_date'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'created_on_date'
        },
        {
          position: 15,
          text: this.$t('msg.gfi_completion_date'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'test_finish_time'
        },
        {
          position: 16,
          text: this.$t('msg.expiry_date'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'expiry_date'
        },
        {
          position: 17,
          text: this.$t('msg.update_details'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'details',
          roles: ['ROLE_LOAN_OFFICER_DASHBOARD'],
          enableForFinanceType: ['MIKRO']
        },
        {
          position: 18,
          text: this.$t('msg.gfi_scoring'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'scoring',
          roles: ['ROLE_LOAN_OFFICER_DASHBOARD'],
          enableForFinanceType: ['MIKRO']
        },

        {
          position: 19,
          text: this.$t('msg.f1'),
          align: 'center',
          value: 'compliance',
          selectedCheckbox: true,
          toggle: false,
          roles: ['ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD']
        },
        {
          position: 20,
          text: this.$t('msg.f2'),
          align: 'center',
          value: 'entrepreneurship',
          selectedCheckbox: true,
          toggle: false,
          roles: ['ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD']
        },
        {
          position: 21,
          text: this.$t('msg.f3'),
          align: 'center',
          value: 'financial_decision_making',
          selectedCheckbox: true,
          toggle: false,
          roles: ['ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD']
        },
        {
          position: 22,
          text: this.$t('msg.gfi_score'),
          align: 'center',
          value: 'test_taker_score_overall_score',
          selectedCheckbox: true,
          toggle: false
        },
        {
          position: 23,
          text: this.$t('msg.gfi_rating'),
          align: 'center',
          value: 'gfi_rating',
          selectedCheckbox: true,
          toggle: false
        },
          {
              position: 24,
              text: this.$t('msg.compliance'),
              align: 'center',
              value: 'compliance',
              selectedCheckbox: true,
              toggle: false,
              roles: ['ROLE_LOAN_OFFICER_DASHBOARD']
          },
        {
          position: 25,
          text: this.$t('msg.report'),
          align: 'center',
          value: 'report',
          selectedCheckbox: true,
          toggle: false,
          roles: ['ROLE_HQ_OFFICER_DASHBOARD','ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD'],
        },
          {
              position: 26,
              text: this.$t('msg.application_status'),
              align: 'center',
              selectedCheckbox: true,
              toggle: false,
              value: 'application_status',
          }
      ],
      checkItemArray: [],
      clickedItem: {},
      pagination: {
        itemsPerPage: 10,
        itemPerPageOptions: [10]
      }, filterBox: {
        scheme: '',
        loanAmount: '',
        gfiStatus: '',
        applicationStatus: '',
        startDate: '',
        branch: ''
      }
    }
  },
  methods: {
    showColumn: function (col) {
      return this.headers.find(h => h.value === col).selected
    },
    hideColumnData: function () {
      this.hideColumn = !this.hideColumn
    },
    prepareDataForRequest: function () {
      return {
        pageSize: this.pagination.itemsPerPage,
        pageNumber: this.pagination.page,
        searchText: this.search,
        scheme: this.filterBox.scheme,
        amount: this.filterBox.loanAmount,
        status: this.filterBox.gfiStatus,
        branch: this.filterBox.branch,
        applicationStatus: this.filterBox.applicationStatus,
        startDate: this.filterBox.startDate,
        financeType: this.userType
      }
    },
    getDataFromApi: function () {
      console.log('data for' + this.userType)
      let data = this.prepareDataForRequest()
      dataServices.getDataForCustomers(data).then(response => {
        this.table.tableData = response.dataResponse.resultData.table_content
        this.table.totalLength = response.dataResponse.resultData.total_rows
        this.tableDataLoading = false
      })
    },
    getDropDownData: function () {
      if (this.userType === 'MIKRO') {
        dataServices.getMikroDataForFilters().then(response => {
          this.populateDropdownData(response)
          this.loadingFilterData = false
        })
      } else if (this.userType === 'SME') {
        dataServices.getSmeDataForFilters().then(response => {
          this.populateDropdownData(response)
          this.loadingFilterData = false
        })
      }
    },
    populateDropdownData: function (response) {
      if (null != response.dataResponse.schemeDropDown) {
        this.schemeDropdownData = response.dataResponse.schemeDropDown
      }
      if (null != response.dataResponse.amountRangeDropDown) {
        this.amountRangeDropdownData = response.dataResponse.amountRangeDropDown
      }
      if (null != response.dataResponse.statusDropDown) {
        this.statusDropdownData = response.dataResponse.statusDropDown
      }
      if (null != response.dataResponse.applicationStatusDropDown) {
        this.applicationStatusDropdownData = response.dataResponse.applicationStatusDropDown
      }
      if (null != response.dataResponse.branchDropDown) {
        this.branchDropdownData = response.dataResponse.branchDropDown
      }
    },
    getEditFilterDropdownData: function () {
      dataServices.getDataForEditFilters().then(response => {
        if (null != response.dataResponse.editGenderDropDownData) {
          this.editGenderFilterDropdownData = response.dataResponse.editGenderDropDownData
        }
        if (null != response.dataResponse.editBusinessDropDownData) {
          this.editBusinessCategoryDropdownData = response.dataResponse.editBusinessDropDownData
        }
        if (null != response.dataResponse.editEthnicityDropDownData) {
          this.editEthnicityDropdownData = response.dataResponse.editEthnicityDropDownData
        }
        this.loading = false
      })
    },
    updateUserInformation: function () {
      dataServices.editUserInformation(this.editedItem).then(response => {
        console.log(response.dataResponse.duplicate)
          if (response.dataResponse.duplicate) {
              console.log('duplicate')
              this.$refs.observerEditApplicationNumber.applyResult({
                  errors: ['error'],
                  failedRules: ['duplicate']
              });
          }else {
              this.paginate()
              this.updated = true
              this.dialog = false
          }
      }).catch(error => {
        this.serverError = true
        console.log('Error' + error)
      })
    },
    updateCustomerApplicationStatus: function () {
      dataServices.editApplicationStatus(this.editApplicationItem).then(response => {
          console.log(response)
              this.paginate()
              this.updated = true
              this.applicationStatusDialog = false
      }).catch(error => {
        this.serverError = true
        console.log('error' + error)
      })
    },
    editItem: function (item) {
      this.dialog = true
      this.editedItem = Object.assign({}, item)
      this.getEditFilterDropdownData()
    },
    editApplicationStatus: function (item) {
      this.applicationStatusDialog = true
      this.editApplicationItem = Object.assign({}, item)
    },
    updatedItem: function () {
      this.updateUserInformation()
    },
    updateApplicationStatus: function () {
      this.updateCustomerApplicationStatus()
    },
    filterData: function () {
      this.appliedFilters.scheme = this.filterBox.scheme
      this.appliedFilters.amount = this.filterBox.loanAmount
      this.appliedFilters.status = this.filterBox.gfiStatus
      this.appliedFilters.finAppStatus = this.filterBox.applicationStatus
      this.appliedFilters.date = this.filterBox.startDate
      this.appliedFilters.branch = this.filterBox.branch
      this.pagination.page = 1
      this.paginate()
        console.log('done filter ')
    },
    resetFilters: function () {
        this.appliedFilters.scheme = ''
        this.appliedFilters.amount = ''
        this.appliedFilters.status = ''
        this.appliedFilters.finAppStatus = ''
        this.appliedFilters.date = ''
        this.appliedFilters.branch = ''
      this.filterBox.scheme = ''
      this.filterBox.loanAmount = ''
      this.filterBox.gfiStatus = ''
      this.filterBox.applicationStatus = ''
      this.filterBox.startDate = ''
      this.filterBox.branch = ''
      this.pagination.page = 1
      this.paginate()
    },
    paginate: function () {
      console.log('paginating.....')
      this.tableDataLoading = true
      this.getDataFromApi()
    },
    generateScore: function (item) {
      this.generateScoreDialog = true
      this.editedItem = Object.assign({}, item)
    },
    generateScoreDialogSuccess: function () {
      this.generateScoreDialog = false
      this.generateScoreSnackbar = true
    },
    exportData: function () {
      if (this.exporting) {
        return false
      }
      this.exportDataDownloadError = false
      this.exporting = true
      let data = this.prepareDataForRequest()
      downloadFileService.downloadExcel(data)
          .then(response => {
            if (response) {
              fileSaver.saveAs(response, 'excel_export.xlsx')
              this.exporting = false

            }
          }).catch(error => {
        this.exporting = false
        this.exportDataDownloadError = true
        /* eslint-disable no-console */
        console.log('loggin response ' + error)
        /* eslint-enable no-console */
      })
    },
    sendGenerateScoreRequest: function () {
      dataServices.scoreCustomer(this.editedItem).then(response => {
        console.log(response)
        this.paginate()
        this.generateScoreDialog = false
        this.generateScoreSnackbar = true
      }).catch(error => {
        console.log('Error' + error)
      })
    },
    downloadReport: function (ttid, idNumber, reportType) {
      this.reportDownloadError = false
      let loaderString = ttid + '-' + idNumber + '-' + reportType
      if (this.requestDataArray.indexOf(loaderString) < 0) {
        this.requestDataArray.push(loaderString)
      }
      downloadFileService.downloadReport({id: ttid})
          .then(response => {
            if (response) {
              fileSaver.saveAs(response, idNumber + '.pdf')
            }
            this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
            this.loading = false
          }).catch(error => {
        this.loading = false
        this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
        this.reportDownloadError = true
        console.log('loggin response ' + error)
      })
    },
    downloadCustomerReport: function (ttid, idNumber, reportType) {
      this.reportDownloadError = false
      let loaderString = ttid + '-' + idNumber + '-' + reportType
      if (this.requestDataArray.indexOf(loaderString) < 0) {
        this.requestDataArray.push(loaderString)
      }
      downloadFileService.downloadCustomerReport({id: ttid})
          .then(response => {
            if (response) {
              fileSaver.saveAs(response, idNumber + '.pdf')
            }
            this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
            this.loading = false
          }).catch(error => {
        this.loading = false
        this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
        this.reportDownloadError = true
        console.log('loggin response ' + error)
      })
    },
    checkArray: function (ttid, idNumber, reportType) {
      return this.requestDataArray.indexOf(ttid + '-' + idNumber + '-' + reportType) < 0
    },
    recordTicks: function () {

      let selectedColumns = this.headers
          .filter(header => (header.toggle && header.selectedCheckbox))
          .map(function (header) {
            return header.position
          })
      this.$cookies.set('cgc-hybrid-' + this.userType, JSON.stringify(selectedColumns))
    },
    clear: function () {

      this.renderEditForm = false

      this.$nextTick(() => {
        this.renderEditForm = true;
      });
      this.serverError = false
      this.dialog = false
    },
    clearApplicationStatus: function (){
      this.applicationStatusDialog=false,
      this.applicationServerError = false
    }
  },
  computed: {
    filteredHeaders: function () {
      return this.filteredHeadersForCheckBox.filter(h => !h.toggle || (h.toggle && h.selectedCheckbox))
    },
    filteredHeadersForCheckBox: function () {
      let currentFinanceType = this.userType
      let role = this.$store.state.home.user.role
      return this.headers.filter(function (e) {
        if (!e.roles || e.roles.length === 0) {
          if (!e.enableForFinanceType || e.enableForFinanceType.length === 0)
            return true
          else
            return e.enableForFinanceType.includes(currentFinanceType)
        } else if (e.roles.includes(role)) {
          if (!e.enableForFinanceType || e.enableForFinanceType.length === 0)
            return true
          else
            return e.enableForFinanceType.includes(currentFinanceType)
        } else {
          return false
        }
      });
    },
    isShowExportButtonEnabled: function () {
      return this.$store.state.home.user.role === 'ROLE_HQ_OFFICER_DASHBOARD'
    },
    isFinancialAdvisoryOfficer: function () {
      return this.$store.state.home.user.role === 'ROLE_FINANCIAL_ADVISORY_OFFICER_DASHBOARD'
    },
      isLoanOfficer: function () {
          return this.$store.state.home.user.role === 'ROLE_LOAN_OFFICER_DASHBOARD'
      },
    getUserRole() {
      return this.$store.state.home.user.role
    },
    isUserAuthenticated() {
      return this.$store.state.home.authenticated
    },
    enableExportButton() {
      return this.table.tableData.length > 0
    }
  },
  created() {
    this.getDropDownData()
    this.getDataFromApi()
    if (this.$cookies.get('cgc-hybrid-' + this.userType)) {
      let selectedColumns = JSON.parse(this.$cookies.get('cgc-hybrid-' + this.userType))
      for (let i = 0; i < this.headers.length; i++) {
        if (selectedColumns.includes(this.headers[i].position)) {
          this.headers[i].selectedCheckbox = true
        }
      }
    }
  },
  watch: {
    'editedItem.commencement_date': function () {
      if (this.editedItem.commencement_date) {
        const [year, month, day] = this.editedItem.commencement_date.substr(0, 10).split('-')
        this.editedCommencementDate = `${day}-${month}-${year}`
      } else
        this.editedCommencementDate = ''
    },
    'editApplicationItem.application_approval_date': function () {
      if (this.editApplicationItem.application_approval_date) {
        const [year, month, day] = this.editApplicationItem.application_approval_date.substr(0, 10).split('-')
        this.editedApplicationApprovedDate = `${day}-${month}-${year}`
      } else
        this.editedApplicationApprovedDate = ''
    },
    'editedItem.ctos_description': function (){
      if (this.editedItem.ctos_description === 'N' || this.editedItem.ctos_description === '' || this.editedItem.ctos_description === null ){
        this.editedItem.ctos_rating = ''
      }
    },
    search: debounce(function (newValue) {
      if (newValue === '') {
        this.getDataFromApi()
      }
    }, 900),
    userType: function () {
      console.log("changed")
      this.getDropDownData()
      this.resetFilters()
      this.$forceUpdate();
    }
  },
}
</script>

<style>
.containerStyling {
  margin-top: 0px;
  margin-bottom: 0px;
}

.customersTablePadding {
  padding-top: 0px;
  padding-bottom: 100px;
}

.mdi-file-download::before {
  cursor: pointer;
}

.requiredSticker label::after {
  content: "*";
  color: red;
}

.textRed{
    color: red;
}
</style>
